import React, { useState, useEffect } from "react";
import logo from "../images/Analytics/Analytics.svg";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

function Home() {
  const storedJwt = localStorage.getItem("token");
  const [jwt] = useState(storedJwt);
  const [isTokenExpired, setIsTokenExpired] = useState(false);

  useEffect(() => {
    if (jwt && jwt !== "null") {
      try {
        const decodedToken = jwtDecode(jwt); // Decoding the token
        const currentTime = Math.floor(Date.now() / 1000);
        if (decodedToken.exp < currentTime) {
          setIsTokenExpired(true);
        } else {
          setIsTokenExpired(false);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setIsTokenExpired(true);
      }
    } else {
      setIsTokenExpired(true);
    }
  }, [jwt]);

  return (
    <>
      {isTokenExpired ? (
        <Navigate to="/SignIn" />
      ) : (
        <div>
          <img src={logo} className="homelogo" alt="logo" />
        </div>
      )}
    </>
  );
}

export default Home;
